import { action, makeObservable, observable, runInAction } from "mobx";
import { checkLogin, login as loginService, sendLoginOtp, OtpSendAgain, register as registerService, RegisterDI, sendRegisterOtp, } from "../services/loginService";
import remotedev from "mobx-remotedev";
import { postRequest } from "../services/urlService";
import { commonUrl } from "../services/urlService";
import { forgotPassword, sendForgotPasswordOtp, sendPassword, tokenCheck, } from "../services/forgotPasswordService";

interface UserDI {
  fullName: string;
  token: string;
  isEditor: boolean;
}

const ADRUM_EMAIL_KEY = "adrumUserEmail";

const setAdrumUser = (user: { userId?: string | number; fullName?: string; email?: string } | null) => {
  if (!user) {
    localStorage.removeItem(ADRUM_EMAIL_KEY);
    (window as any).__railUser = null;
    return;
  }
  let email = user.email || "";
  if (email) {
    localStorage.setItem(ADRUM_EMAIL_KEY, email);
  } else {
    email = localStorage.getItem(ADRUM_EMAIL_KEY) || "";
  }
  const id = email || (user.userId != null ? String(user.userId) : "");
  (window as any).__railUser = id
    ? { userId: id, fullName: user.fullName || "", email }
    : null;
};

interface LogoutResponseDI { }

export interface ResponseDI<T> {
  creationDate: Date;
  errorMessages: string | string[] | null;
  result: T;
  statusCode: number;
}

export class UserStore {
  user!: UserDI | null;
  phone!: string;
  completedOtp: boolean;

  constructor() {
    makeObservable(this, {
      user: observable,
      phone: observable,
      completedOtp: observable,
      setPhone: action,
      logout: action,
      setUser: action,
      setCompletedOtp: action,
      checkLogin: action,
      login: action,
      sendOtpLogin: action,
    });
    this.completedOtp = false;
  }

  logout = async () => {
    await postRequest<{}, ResponseDI<LogoutResponseDI>>(`${commonUrl}/api/user/logout`, {});
    runInAction(() => {
      this.user = null;
    });
    (window as any).gtag("config", "G-SRPQZDZ016", { user_id: "ANONYMOUS" });
    setAdrumUser(null);
  };


  logoutEntra = async (instance: any) => {
    runInAction(() => {
      this.user = null;
      this.setCompletedOtp(false);
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      localStorage.removeItem("entraToken");
      sessionStorage.removeItem("token");
    });
  
    // הפעלת הלוגאאוט דרך Entra
    // instance.logoutRedirect({
    //   postLogoutRedirectUri: window.location.origin + "/login", // הפניה ל-/login

    // });

    // instance.logoutRedirect({

    //   account: instance.getActiveAccount(), // או להשאיר account ריק
    //   postLogoutRedirectUri: window.location.origin + "/login",
    //   onRedirectNavigate: () => false, // מונע ניתוב חיצוני
    // });

    window.location.href = "/login";
  };
  
  checkLogin = async () => {
    try {
      const { isEditor, token, fullName, userId, email } = await checkLogin();
      runInAction(() => {
        const user = { isEditor, token, fullName, userId };
        this.setUser(user);
        !!fullName && (window as any).gtag("config", "G-SRPQZDZ016", { user_id: userId });
        setAdrumUser({ userId, fullName, email });
      });
    } catch (error: any) {
      // Error handled silently
    }
  };

  forgotPassword = async (code: string) => {
    await forgotPassword(code);
    this.setCompletedOtp(true);
  };

  sendForgotPasswordOtp = async (email: string) => {
    this.setCompletedOtp(false);
    await sendForgotPasswordOtp(email);
  };

  checkValidToken = async (token: string) => await tokenCheck(token);

  setUser = (user: UserDI) => {
    this.user = user;
    // Save token to localStorage for cross-domain API calls
    if (user?.token) {
      localStorage.setItem("authToken", user.token);
    }
  };

  setPhone = (phone: string | undefined) => {
    this.phone = phone ?? "";
  };

  setCompletedOtp = (completed: boolean) => (this.completedOtp = completed);

  resetPassword = async (password: string, token: string) => await sendPassword(password, token);

  sendOtpLogin = async ({ email, password, }: { email: string; password: string | number; }) => {
    this.setCompletedOtp(false);
    const response = await sendLoginOtp({ email, password });
    if (response?.phone) this.setPhone(response.phone);
  };

  OtpSendAgain = async (authType: string) => {
    const capitalizedAuthType = authType.charAt(0).toUpperCase() + authType.slice(1);
    return await OtpSendAgain(`Send${capitalizedAuthType}Otp`);
  };

  login = async ({ code }: { code: string }) => {
    const { token, fullName, isEditor, email, userId } = await loginService({ code });
    runInAction(() => {
      const user = { isEditor,fullName , token, email, userId, };
      this.setUser(user);
      this.setCompletedOtp(true);
      (window as any).gtag("config", "G-SRPQZDZ016", { user_id: userId });
      setAdrumUser({ userId, fullName, email });
    });
  };
 loginEntra = async ({ token, fullName, isEditor, email, userId }: { 
  token: string; 
  fullName: string; 
  isEditor: boolean; 
  email?: string; 
  userId: number;
}) => {
  runInAction(() => {
    const user = { isEditor, email, token, fullName, userId };
    this.setUser(user);
    // Save the Entra ID JWT token for cross-domain xAPI calls
    localStorage.setItem("entraToken", token);
    this.setCompletedOtp(true);
    (window as any).gtag("config", "G-SRPQZDZ016", { user_id: userId });
    setAdrumUser({ userId, fullName, email });
  });
};

  sendOtpRegister = async ({ email, password, company, name, role, phone, }: RegisterDI) => {
    this.setCompletedOtp(false);
    const response = await sendRegisterOtp({ email, password, name, company, role, phone, });
    if (response?.phone) this.setPhone(response.phone);
  };

  register = async (OtpCode: string) => {
    await registerService({ OtpCode });
    this.setCompletedOtp(true);
  };
}

const withRemoteDev = remotedev(UserStore);
export default new withRemoteDev();
